import { useI18n } from "vue-i18n";
import { getErrorMessage } from "@/shared/utils/error";

export const useGetBleErrorMessage = () => {
  const { t } = useI18n();

  return (error: any) => {
    switch (error?.message) {
      case "Not Accepted":
        return t("BleAuthNotAcceptedErrorText");
      case "Not synched":
        return t("BleAuthNotSynchedErrorText");
      case "Full":
        return t("BleAuthFullErrorText");
      case "NOT AUTHORIZED":
        return t("BleAuthNotAuthorizedErrorText");
      case "Timeout has occurred":
      case "Connection timeout":
        return t("BleTimeoutErrorText");
      default:
        // Unmapped errors (raw native BLE strings, tagged technical errors)
        // fall back to the centralized handler, which hides technical ones
        // behind the generic message.
        return getErrorMessage(error);
    }
  };
};
